import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const FilterPanel = ({
  isOpen,
  onClose,
  selectedCategory,
  selectedLocation,
  onCategoryChange,
  onLocationChange,
  categories,
  locations
}) => {
  if (!isOpen) return null;

  const clearAllFilters = () => {
    onCategoryChange('all');
    onLocationChange('all');
  };

  const hasActiveFilters = selectedCategory !== 'all' || selectedLocation !== 'all';

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />
      
      {/* Panel */}
      <div className="absolute bottom-0 left-0 right-0 bg-card rounded-t-lg border-t border-border max-h-[80vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-foreground">Filters</h3>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
            >
              <Icon name="X" size={20} />
            </Button>
          </div>

          {/* Filter Options */}
          <div className="space-y-6">
            {/* Category Filter */}
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Category
              </label>
              <Select
                value={selectedCategory}
                onValueChange={onCategoryChange}
                placeholder="Select category"
                options={categories}
                fullWidth
              />
            </div>

            {/* Location Filter */}
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Location
              </label>
              <Select
                value={selectedLocation}
                onValueChange={onLocationChange}
                placeholder="Select location"
                options={locations}
                fullWidth
              />
            </div>

            {/* Additional Filter Options */}
            <div className="border-t border-border pt-6">
              <h4 className="text-sm font-medium text-foreground mb-3">
                Business Type
              </h4>
              <div className="space-y-2">
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    className="rounded border-border text-primary focus:ring-primary"
                  />
                  <span className="text-sm text-foreground">Featured Businesses</span>
                </label>
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    className="rounded border-border text-primary focus:ring-primary"
                  />
                  <span className="text-sm text-foreground">Verified Businesses</span>
                </label>
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    className="rounded border-border text-primary focus:ring-primary"
                  />
                  <span className="text-sm text-foreground">Recently Added</span>
                </label>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-3 mt-8 pt-6 border-t border-border">
            {hasActiveFilters && (
              <Button
                variant="outline"
                onClick={clearAllFilters}
                iconName="RotateCcw"
                iconPosition="left"
                iconSize={16}
                className="flex-1"
              >
                Clear All
              </Button>
            )}
            <Button
              variant="default"
              onClick={onClose}
              className="flex-1"
            >
              Apply Filters
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;